import { render, staticRenderFns } from "./UDIrukuDialogNew.vue?vue&type=template&id=d3e5a80a&scoped=true"
import script from "./UDIrukuDialogNew.vue?vue&type=script&lang=js"
export * from "./UDIrukuDialogNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3e5a80a",
  null
  
)

export default component.exports